import type { UseCase } from '@/core/shared'
import type { ChargePointRepository } from '../domain'

export const getAllBrandingInfo: UseCase<ChargePointRepository, 'getAllBranding'> = (repository) => {
  return async () => {
    return await repository.getAllBranding()
  }
}
